var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssetsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "#EFF0FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 20.5H34.5M20.5 20.5L20.5 34.5M19.1 13.5H28.9C30.8602 13.5 31.8403 13.5 32.589 13.8815C33.2475 14.217 33.783 14.7525 34.1185 15.411C34.5 16.1597 34.5 17.1398 34.5 19.1V28.9C34.5 30.8602 34.5 31.8403 34.1185 32.589C33.783 33.2475 33.2475 33.783 32.589 34.1185C31.8403 34.5 30.8602 34.5 28.9 34.5H19.1C17.1398 34.5 16.1597 34.5 15.411 34.1185C14.7525 33.783 14.217 33.2475 13.8815 32.589C13.5 31.8403 13.5 30.8602 13.5 28.9V19.1C13.5 17.1398 13.5 16.1597 13.8815 15.411C14.217 14.7525 14.7525 14.217 15.411 13.8815C16.1597 13.5 17.1398 13.5 19.1 13.5Z",
    stroke: "#6366F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetsIcon);
export default __webpack_public_path__ + "static/media/assetsIcon.c3e012cae3f3939c94bbef0b983aea48.svg";
export { ForwardRef as ReactComponent };